import { Popup, PopupOptions, PopupsManager } from '@funtech-int/web-toolkit';
import { ReactElement } from 'react';

type ToastNotificationType =
    | 'BOOKMARK'
    | 'DONE'
    | 'FAIL'
    | 'NOTINTERESTED'
    | 'SUCCESS'
    | 'UNBOOKMARK'
    | 'UNDONOTINTERESTED';

export type ToastNotificationViewVariant = 'BOTTOM' | 'BOTTOMDARK' | 'TOP' | 'TOPDARK';

export type ToastNotification = {
    type: ToastNotificationType;
    message: string;
    viewVariant: ToastNotificationViewVariant;
    showTime?: number;
};
export function isToast(popup: Popup<any>): popup is Popup<ToastNotification> {
    return popup.kind === 'toast';
}

interface Modal {
    content: ReactElement;
    className?: string;
    closeButtonClassName?: string;

    onClose?: () => void;
    // add more on demand
}

interface ContentModal {
    content: ReactElement;

    onClose?: () => void;
    // add more on demand
}

export function isModal(popup: Popup<any>): popup is Popup<Modal> {
    return popup.kind === 'modal';
}

export function isContentModal(popup: Popup<any>): popup is Popup<ContentModal> {
    return popup.kind === 'contentModal';
}

interface PopupsHandler<T> {
    show(payload: T, options?: PopupOptions): number;
    hide(id: number): void;
}

export function createPopupHandler<T>(
    popups: PopupsManager,
    kind: 'toast' | 'modal' | 'contentModal'
): PopupsHandler<T> {
    return {
        show(payload: T, options: PopupOptions = { key: kind }) {
            return popups.show(kind, payload, options);
        },
        hide: (id: number) => {
            popups.hide(id);
        },
    };
}

export type ToastHandler = PopupsHandler<ToastNotification>;

export type ModalHandler = PopupsHandler<Modal>;

export type ContentModalHandler = PopupsHandler<ContentModal>;
